import { render, staticRenderFns } from "./VaAdvancedColorPicker.vue?vue&type=template&id=21da9dd4&"
import script from "./VaAdvancedColorPicker.vue?vue&type=script&lang=js&"
export * from "./VaAdvancedColorPicker.vue?vue&type=script&lang=js&"
import style0 from "./VaAdvancedColorPicker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports